var MiniCart = {
	
	timeoutHandler:0,
	
	init:function(){
		$(".header .woocommerce-cart").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			MiniCart.open_cart();
		});
		$(".mini-cart-container .close").on("click touchend", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			MiniCart.close_cart();
		});
		setTimeout(function(){
			$("body").on("wc_fragments_loaded", function(){
				Debug.log("wc_fragments_loaded");
				MiniCart.open_cart();
			});
		},1000);


		$("body").on("added_to_cart", function(){
			MiniCart.update_count();
		});
		
		$(".header .right").find(".count").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			Debug.log("CLICK COUNT : " + $(".mini-cart-container .widget").length);
			/*if($(".mini-cart-container .widget").length){*/
				MiniCart.open_cart();
			/*}*/
		});
	},
	update_count:function(){

		var _count = 0;

		$(".mini-cart-container .mini-cart-item").each(function(){
			_count += parseInt($(this).find(".qty.text").val());
		});

		Debug.log("MINI CART UPDATE COUNT : " + _count);
		if(_count <= 0){
			$(".header .count").addClass("empty");
			$(".header .right").removeClass("cart-filled");
			$(".header .count").html("");
			MiniCart.close_cart();
		}else{
			$(".header .count").removeClass("empty");
			$(".header .right").addClass("cart-filled");
			$(".header .count").html(_count);
		}

	},
	open_cart:function(){

		Debug.log("OPEN CART")

		$(".mini-cart-container").addClass("open");
		$(".mini-cart-container .shadow").off("click touchend");
		
		clearTimeout(MiniCart.timeoutHandler);
		MiniCart.timeoutHandler = setTimeout(function(){
			$(".mini-cart-container .shadow").on("click touchend", function(e){
				if(e.type == 'touchend'){
					$(this).off("click");
				}
				MiniCart.close_cart();
			});
		}, 100);
	},
	close_cart:function(){
		Debug.log("CLOSE CART");
		$(".mini-cart-container .shadow").off("click touchend");
		$(".mini-cart-container").removeClass("open");
	}
}

$(window).load(function(){
	if($(".mini-cart-container").length){
		MiniCart.init();
	}
})